var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._b({attrs:{"type":"number","rules":_vm.getFieldRules()},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'v-text-field',_vm.getProps(),false))}
var staticRenderFns = []

export { render, staticRenderFns }